var _minimatch = require("minimatch");

var _require = require("../helper"),
    validGTrackingId = _require.validGTrackingId,
    getCookie = _require.getCookie,
    initializeGTagJS = _require.initializeGTagJS;

exports.addGoogleTag = function (options) {
  return new Promise(function (resolve, reject) {
    if (window.gatsbyPluginGDPRCookiesGoogleTagAdded) return resolve(true);
    var pluginConfig = options.pluginConfig || {};
    var origin = pluginConfig.origin || "https://www.googletagmanager.com";
    var head = document.getElementsByTagName("head")[0];
    var link = document.createElement("link");
    link.rel = "preconnect";
    link.key = "preconnect-google-gtag";
    link.href = origin;
    var link2 = document.createElement("link");
    link2.rel = "dns-prefetch";
    link2.key = "dns-prefetch-google-gtag";
    link2.href = origin;
    var firstTrackingId = options.trackingIds && options.trackingIds.length ? options.trackingIds[0] : "";
    var script = document.createElement("script");
    script.key = "gatsby-plugin-google-gtag";
    script.async = true;

    script.onload = function () {
      window.gatsbyPluginGDPRCookiesGoogleTagAdded = true;
      resolve(true);
    };

    script.src = origin + "/gtag/js?id=" + firstTrackingId;
    head.appendChild(link);
    head.appendChild(link2);
    head.appendChild(script);
  });
};

exports.initializeGoogleTag = function (options, consentOptions) {
  if (!window.gatsbyPluginGDPRCookiesGoogleTagInitialized && validGTrackingId(options)) {
    var gtagConfig = options.gtagConfig || {};
    var pluginConfig = options.pluginConfig || {}; // Prevent duplicate or excluded pageview events being emitted on initial load of page by the `config` command
    // https://developers.google.com/analytics/devguides/collection/gtagjs/#disable_pageview_tracking

    gtagConfig.send_page_view = false;
    var excludeGtagPaths = []; // (function(){

    if (typeof pluginConfig.exclude !== "undefined") {
      pluginConfig.exclude.map(function (exclude) {
        var mm = new _minimatch.Minimatch(exclude);
        excludeGtagPaths.push(mm.makeRe());
      });
    }

    var firstTrackingId = options.trackingIds && options.trackingIds.length ? options.trackingIds[0] : "";
    var restTrackingIds = options.trackingIds.slice(1);

    var renderHtml = function renderHtml() {
      return "\n      " + (excludeGtagPaths.length ? "window.excludeGtagPaths=[" + excludeGtagPaths.join(",") + "];" : "") + "\n      " + (typeof gtagConfig.anonymize_ip !== "undefined" && gtagConfig.anonymize_ip === true ? "function gaOptout(){document.cookie=disableStr+'=true; expires=Thu, 31 Dec 2099 23:59:59 UTC;path=/',window[disableStr]=!0}var gaProperty='" + firstTrackingId + "',disableStr='ga-disable-'+gaProperty;document.cookie.indexOf(disableStr+'=true')>-1&&(window[disableStr]=!0);" : "") + "\n      if(" + (pluginConfig.respectDNT ? '!(navigator.doNotTrack == "1" || window.doNotTrack == "1")' : "true") + ") {\n        " + initializeGTagJS(consentOptions) + "\n        " + restTrackingIds.map(function (trackingId) {
        return "window.gtag('config', '" + trackingId + "', " + JSON.stringify(gtagConfig) + ");";
      }).join("") + "\n      }\n      ";
    };

    var script = document.createElement("script");
    script.key = "gatsby-plugin-google-gtag-config";
    script.innerHTML = renderHtml();
    var head = document.getElementsByTagName("head")[0];
    head.appendChild(script);
    window.gatsbyPluginGDPRCookiesGoogleTagInitialized = true;
  }
};

exports.trackGoogleTag = function (options, location) {
  if (!window.gatsbyPluginGDPRCookiesGoogleTagInitialized && getCookie(options.cookieName) === "true" && validGTrackingId(options)) {
    var pathIsExcluded = location && typeof window.excludeGtagPaths !== "undefined" && window.excludeGtagPaths.some(function (rx) {
      return rx.test(location.pathname);
    });
    if (pathIsExcluded) return null; // wrap inside a timeout to make sure react-helmet is done with its changes (https://github.com/gatsbyjs/gatsby/issues/11592)

    var sendPageView = function sendPageView() {
      var pagePath = location ? location.pathname + location.search + location.hash : undefined;
      window.gtag("event", "page_view", {
        page_path: pagePath
      });
    };

    if ("requestAnimationFrame" in window) {
      requestAnimationFrame(function () {
        requestAnimationFrame(sendPageView);
      });
    } else {
      // simulate 2 rAF calls
      setTimeout(sendPageView, 32);
    }
  }
};